<template>
  <div>
    <div class="flex assinged-cutomer flex-align-items-baseline">
      <div
        :class="{'card py-3 py-4-md px-4 half-width': true, 'mx-auto': readonly}">
        <h2 :class="{'heading-bigger':true, 'mb-4': !readonly, 'mb-2': readonly,}">
          <template v-if="readonly">
            {{ $t('inquiryAssignedCustomer.selectedCustomer') }}
          </template>
          <template v-else>
            {{ $t('inquiryAssignedCustomer.selectExistingProfile') }}
          </template>
        </h2>
        <div
          v-if="!isCustomerDeleted"
          :class="{'form-group':true, 'mb-3': !readonly}">
          <template v-if="!readonly">
            <label for="name">{{ $t('inquiryAssignedCustomer.searchCustomer') }}</label>
            <f-input-wrapper
              prependIcon="search">
              <f-input
                :placeholder="$t('ui.search')"
                :disabled="readonly"
                v-model="customerSearchInput"
                @input="filterByForCustomers"/>
            </f-input-wrapper>
          </template>

          <div
            v-if="(selectedCustomerID && customer) || (isNotAcceptedCustomer && customer)"
            class="my-2">
            <strong v-if="!readonly">{{ $t('communicationSms.customersChoose.choose') }}</strong>
            <div class="flex py-2 bg-highlight px-2">
              <img
                class="customer-avatar mr-2"
                :src="customer.img ? customer.img : require('@/assets/images/default-avatar.png')"
                :alt="customer.name + ''  + customer.surname + ' avatar'" />
              <div class="mr-2">
                <span class="text-medium ">{{ customer.name }} {{ customer.surname }}</span><br>
                <span class="small">#{{ customer.id }}</span> <span class="small separator">&bull;</span> <span class="small">{{ customer.city }}</span>
              </div>
            </div>

          </div>

          <div
            v-for="(item, index) in filteredCustomers"
            :key="index"
            :class="{
              'flex': true,
              'border-bottom': index !== filteredCustomers.length - 1,
              'py-2': true
            }">
            <img
              class="customer-avatar mr-2"
              :src="item.img ? item.img : require('@/assets/images/default-avatar.png')"
              :alt="item.name + ''  + item.surname + ' avatar'" />
            <div class="mr-2">
              <span class="text-medium ">{{ item.name }} {{ item.surname }}</span><br>
              <span class="small">#{{ item.id }}</span> <span class="small separator">&bull;</span> <span class="small">{{ item.city }}</span>
            </div>

            <f-button
              :disabled="readonly || (item.id === selectedCustomerID)"
              class="ml-auto"
              theme="primary"
              @click.prevent="selectCustomer(item)">
              <template v-if="item.id === selectedCustomerID">
                {{ $t('communicationSms.customersChoose.choose') }}
              </template>
              <template v-else>
                {{ $t('user.choose') }}
              </template>
            </f-button>
          </div>
        </div>

        <f-button
          v-if="!readonly && selectedCustomerID"
          :disabled="!selectedCustomerID"
          class="ml-auto mt-auto mb-auto"
          theme="danger"
          @click.prevent="selectCustomer(null)">
          {{ $t('inquiryAssignedCustomer.deleteChoose') }}
        </f-button>

        <f-alert
          v-if="isCustomerDeleted"
          theme="danger"
          visible
          small>
          <span v-pure-html="$t('inquiryAssignedCustomer.selectedAccountCustomerNoExits')">
          </span>
        </f-alert>

        <f-alert
          v-if="customer && customer.customer_status && customer.customer_status !== 'INVITATION_CONFIRMED'"
          class="mt-3"
          theme="warning"
          visible
          small>
          {{ $t('inquiryAssignedCustomer.youCantChangeStatusOffer') }}
        </f-alert>
      </div>

      <span v-if="!readonly" class="text-between text-center my-4 my-3-md">{{ $t('ui.or') }}</span>

      <div
        v-if="!readonly"
        class="card py-3 py-4-md px-4 half-width">
        <h2 class="heading-bigger mb-3">{{ $t('customerFormWrapper.addNewCustomer') }}</h2>
        <customer-form
          :readonly="false"
          :isInInquiry="true"
          :disabled="!!selectedCustomerID || readonly" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import CustomerForm from '@/views/forms/customer/CustomerForm.vue';

export default {
  name: 'inquiry-assigned-customer',
  components: {
    'customer-form': CustomerForm
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isDuplicate: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      userType: null,
      customer: {},
      allCustomers: [],
      filteredCustomers: [],
      customersLoaded: false,
      customerSearchInput: '',
      selectedCustomerID: 0,
      loadError: false,
      isNotAcceptedCustomer: false,
      isCustomerDeleted: false
    }
  },
  mounted () {
    this.$bus.$on('inquiry-form-set-customer', this.loadAdditionalData);
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    this.loadAdditionalData();
  },
  methods: {
    setCurrentCustomer (currentCustomer, isNotAcceptedCustomer = false) {
      Vue.set(this, 'isNotAcceptedCustomer', isNotAcceptedCustomer);

      if (this.isNotAcceptedCustomer) {
        Vue.set(this, 'customer', currentCustomer);

        if (this.customersLoaded) {
          this.setInvitedCustomer();
        }
      }

      let newCustomerID = 0;

      if (currentCustomer) {
        newCustomerID = currentCustomer.id;
      }

      Vue.nextTick(() => {
        Vue.set(this, 'customer', JSON.parse(JSON.stringify(currentCustomer)));
        Vue.set(this, 'selectedCustomerID', newCustomerID);
        if (!this.isNotAcceptedCustomer) {
          this.$bus.$emit('inquiry-customer-selected', currentCustomer);
        }
        this.$bus.$emit('inquiry-main-part-complete', this.index, !!newCustomerID);
      });
    },
    setInvitedCustomer (newCustomer = null) {
      let currentCustomerEmail = this.customer;

      if (newCustomer) {
        currentCustomerEmail = newCustomer.email;
      }
      let newCustomerInList = this.allCustomers.find(item => item.email === currentCustomerEmail);

      if (newCustomerInList) {
        Vue.set(this, 'customer', JSON.parse(JSON.stringify(newCustomerInList)));
        Vue.set(this, 'selectedCustomerID', 0);
        this.$bus.$emit('inquiry-main-part-complete', this.index, true);

        if (!this.readonly || this.isDuplicate) {
          this.$bus.$emit('inquiry-customer-selected', newCustomerInList);
        }
      } else {
        if (this.isDuplicate) {
          Vue.set(this, 'customer', null);
          return;
        }
        Vue.set(this, 'isCustomerDeleted', true);
      }
    },
    loadAdditionalData(newCustomer = null) {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/' + this.userType + '/customers/items',
        method: 'get',
        outputKey: 'allCustomers',
        loadedKey: 'customersLoaded',
        errorKey: 'loadError',
        params: {
          pagination: 0
        },
        successAction: () => {
          Vue.nextTick(() => {
            if (newCustomer) {
              Vue.set(this, 'isNotAcceptedCustomer', true);
            }
            if (this.isNotAcceptedCustomer || newCustomer) {
              this.setInvitedCustomer(newCustomer);
            }
          });
        }
      });
    },
    filterByForCustomers () {
      this.filteredCustomers = this.allCustomers.filter(item => (item.name + ' ' + item.surname).toLocaleLowerCase('pl').indexOf(this.customerSearchInput.toLocaleLowerCase('pl')) > -1);
    },
    selectCustomer (selectedCustomer) {
      let selectedCustomerID = 0;
      if (selectedCustomer) {
        selectedCustomerID = selectedCustomer.id;
      }
      Vue.set(this, 'selectedCustomerID', selectedCustomerID);
      Vue.set(this, 'customer', JSON.parse(JSON.stringify(selectedCustomer)));
      this.$bus.$emit('inquiry-customer-selected', selectedCustomer);
      this.$bus.$emit('inquiry-main-part-complete', this.index, !!selectedCustomerID);
    },
    getData () {
      return this.customer;
    }
  },
  beforeDestroy () {
    this.$bus.$off('inquiry-form-set-customer', this.loadAdditionalData);
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.text-between {
  color: $color-text-superlight;
  font-size: var(--font-size-title);
  font-weight: 600;
  margin-left: 33px;
  margin-right: 33px;
}

.customer-avatar {
  border-radius: 3px;
  height: 44px;
  width: 44px;
}

.separator {
  padding: 0 3px;
}

@media screen and (max-width: $media-desktop-m) {
  .text-between {
    margin: 40px 20px;
  }
}

@media screen and (max-width: $media-tablet-l) {
  .assinged-cutomer {
    flex-direction: column;

    .half-width {
      width: 100%!important;
    }
  }
}

</style>
